import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "@mikros/library";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useState, useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { MenuOptions } from "./menuOptions";
import { useIntl } from "react-intl";

export interface SiteContainerProps {
  menu: MenuItem[];
  logout: () => void;
  accId?: any;
  subId?: any;
  userName?: string;
}

export function SiteContainer(props: SiteContainerProps) {
  const intl = useIntl();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<number>();
  const [title, setTitle] = useState<string>("");
  const [isDropDownVisible, setDropDownVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  // const accntId="2fadf459-a50d-4b71-917d-8a0cf141b3c1"
  const accntId = props.accId;

  console.log("print acc id in site container", accntId);
  // const userId="4edd7e34-23b9-477d-ad5c-438cb3335983"
  const userId = props.subId;

  const location = useLocation();

  useEffect(() => {
    try {
      setTitle(JSON.parse(location.state).name);
    } catch (e: any) {
      let title = location.state;
      setTitle(title);
    }
  }, [location.state]);

  const options = [
    {
      // label: "Organization Settings",
      label: intl.formatMessage({ id: "siteContainer.orgSettingsLabel" }),
      value: "OrgSet",
      labelWidth: 40,
    },
    {
      label: intl.formatMessage({ id: "siteContainer.personalSettingsLabel" }),
      value: "PerSet",
      labelWidth: 40,
    },
    {
      label: intl.formatMessage({ id: "siteContainer.logout" }),
      value: "logout",
      labelWidth: 40,
    },
  ];

  async function menuSelected(data: any) {
    if (data === "OrgSet") {
      console.log("inside organizational settings");
      navigate("/organization/" + accntId);
      setTitle(intl.formatMessage({ id: "siteContainer.organization" }));
    }
    if (data === "PerSet") {
      console.log("inside personal settings");
      navigate("/personal/" + userId);
      setTitle(intl.formatMessage({ id: "siteContainer.personal" }));
    }
    if (data === "logout") {
      console.log("inside logout");
      props.logout();
      
    }
  }

  useEffect(() => {
    props.menu.forEach((item, index) => {
      if (item.link === location.pathname) {
        setSelectedTab(index);
      }
    });
  }, [location.pathname, props.menu]);

  const handleOptionSelect = (event: any) => {
    setSelectedOption(event.target.value);
    setDropDownVisible(false);
  };

  return (
    <div className="w-full h-screen flex columns-2">
      <div className="w-1/6">
        <div className="h-full bg-mk-primary-15 flex-row">
          <div className="py-4 flex justify-center items-center">
            <img src="Mikros_Logo-02.png" width={200} height={75}></img>
          </div>

          {/* </h1> */}
          <div>
            <div className="flex-col">
              {props.menu.map((menuItem, index) => (
                <Link state={`${menuItem.text}`} to={menuItem.link}>
                  <div
                    key={index}
                    onClick={() => {
                      setSelectedTab(index);
                      setTitle(menuItem.title);
                    }}
                    className={` flex items-center w-full text-xs text-mk-primary-bright font-bold h-10 ${
                      selectedTab === index && "bg-mk-primary text-white"
                    }`}
                  >
                    <FontAwesomeIcon
                      icon={["far", menuItem.icon as IconName]}
                      className="h-6 w-6 mx-2 md:pr-5"
                      // className="h-4 w-4"
                    />
                    {menuItem.text}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="w-5/6 h-full">
        <div className=" h-[6.5%] flex bg-mk-primary-15 justify-between items-center">
          <div className="text-mk-primary-bright pl-[2%] pb-2 font-bold self-end text-xl">
            {title}
          </div>
          <div className="flex justify-center pr-8 space-x-4 items-center">
            <div className="flex items-center bg-white rounded-md"></div>

            <div className="pb-[3%]">
              {/* S */}
              <MenuOptions
                options={options}
                onSelect={(data: any) => {
                  menuSelected(data);
                }}
              >
                <div
                  className="text-white bg-mk-primary font-bold text-lg rounded-3xl h-10 w-10 flex items-center justify-center cursor-pointer"
                  // onClick={handleClick}
                >
                  {props.userName ? props.userName[0].toUpperCase() : "S"}
                </div>
              </MenuOptions>
            </div>
            {isDropDownVisible && (
              <DropDownList
                data={[
                  // "Organization Settings",
                  //  "Personal Settings",
                  intl.formatMessage({ id: "siteContainer.orgSettingsLabel" }),
                  intl.formatMessage({
                    id: "siteContainer.personalSettingsLabel",
                  }),
                ]}
                value={selectedOption}
                onChange={handleOptionSelect}
              />
            )}
          </div>
        </div>
        <div className="h-full flex flex-row bg-mk-primary-10 flex-wrap flex-1 flex-grow content-start px-4 overflow-auto">
          <div id="site-container" className="w-full h-full p-5">
            <div className="flex-1 w-full h-full">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
